document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper !== 'undefined') {
    setTimeout(function () {
      document.querySelectorAll('.swiper').forEach(function (slider) {
        if (slider.swiper && slider.swiper.params.pagination) {
          slider.swiper.params.pagination.dynamicBullets = true;
          slider.swiper.params.pagination.dynamicMainBullets = 5;

          slider.swiper.pagination.destroy();
          slider.swiper.pagination.init();
          slider.swiper.pagination.render();
          slider.swiper.pagination.update();
        }
      });
    }, 800); // delay so Shopify's theme JS finishes
  }
});


(function() {
  const origFetch = window.fetch;
  let freightCalculating = false;
  let realCartItems = null;

  window.fetch = function(url, options, ...rest) {
    const urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    const stack = new Error().stack || '';
    const isFromFreightApp = stack.includes('productPage.js');

    // Detect freight app starting a calculation cycle
    if (urlStr.includes('/cart/shipping_rates') && isFromFreightApp) {
      freightCalculating = true;
      setTimeout(() => { freightCalculating = false; }, 5000);
    }

    // Block cart/clear entirely from freight app
    if (urlStr.includes('/cart/clear') && isFromFreightApp) {
      console.warn('[Cart Fix] Blocked cart/clear from freight app');
      return Promise.resolve(new Response(
        JSON.stringify({ items: [] }),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      ));
    }

    // Block duplicate cart/add from freight app's calculation cycle
    if ((urlStr.includes('/cart/add')) && isFromFreightApp) {
      console.warn('[Cart Fix] Blocked cart/add from freight app calculation');
      return Promise.resolve(new Response(
        JSON.stringify({ items: [] }),
        { status: 200, headers: { 'Content-Type': 'application/json' } }
      ));
    }

    return origFetch(url, options, ...rest);
  };
})();



/* Show selected variant value next to each option label (CW, Aug 2026) */
(function () {
function showSelected() {
try {
var sets = document.querySelectorAll('variant-radios fieldset, fieldset.product-form__input');
for (var i = 0; i < sets.length; i++) {
var fs = sets[i];
var legend = fs.querySelector('legend') || fs.querySelector('.form__label');
var checked = fs.querySelector('input[type=radio]:checked');
if (!legend || !checked) continue;
var first = legend.firstChild;
if (first && first.nodeType === 3) {
var trimmed = first.nodeValue.replace(/\s+$/, '');
if (first.nodeValue !== trimmed) first.nodeValue = trimmed;
}
var span = legend.querySelector('.cw-selected-value');
if (!span) {
span = document.createElement('span');
span.className = 'cw-selected-value';
legend.appendChild(span);
}
span.style.fontWeight = '400';
span.style.margin = '0';
span.style.padding = '0';
var text = ': ' + checked.value;
if (span.textContent !== text) span.textContent = text;
}
} catch (e) {}
}
function refresh() {
showSelected();
setTimeout(showSelected, 200);
setTimeout(showSelected, 600);
}
document.addEventListener('change', function (e) {
if (e.target && e.target.type === 'radio') refresh();
});
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', refresh);
} else {
refresh();
}
})();


/* Mobile-only footer accordions + compact Opening Hours (CW, 30 Aug 2026)
   The live footer section is footer_style3: wrapper .footer-style3, link
   columns carry .footer-block--menu with an h2.footer-block__heading followed
   by a direct ul.footer_menu (there is no .menu-list wrapper in this section).
   Runs only below 750px. Desktop markup and styling are never touched.
   The mobile rules also hide the theme's Back-to-Top button (#to-top), which
   is not wanted on mobile now the footer is short. Desktop keeps it. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var STYLE_ID = 'cw-footer-acc-style';

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '@media screen and (max-width:749px){' +
      '#to-top.dt-sc-to-top{display:none !important;}' +
      '.footer-style3 .footer-block__details-content.rte p{margin:0 0 2px !important;line-height:1.4 !important;}' +
      '.footer-style3 .footer-block__details-content.rte p:first-child{margin-bottom:8px !important;}' +
      '.footer-style3 .footer-block__details-content.rte{margin-bottom:0 !important;padding-bottom:0 !important;}' +
      '.footer-style3 .footer-block.logo{margin-bottom:8px !important;padding-bottom:0 !important;}' +
      '.footer-style3 .footer-block--menu{margin-top:0 !important;margin-bottom:0 !important;}' +
      '.cw-footer-acc{border-top:1px solid rgba(255,255,255,.14);}' +
      '.cw-footer-acc>summary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:13px 0;}' +
      '.cw-footer-acc>summary::-webkit-details-marker{display:none;}' +
      '.cw-footer-acc>summary>h2{margin:0 !important;}' +
      '.cw-footer-acc>summary::after{content:"\\002B";font-size:2.4rem;line-height:1;opacity:.85;}' +
      '.cw-footer-acc[open]>summary::after{content:"\\2212";}' +
      '.cw-footer-acc ul.footer_menu{margin:0 0 10px !important;padding:0 !important;}' +
      '.cw-footer-acc ul.footer_menu li{margin:0 !important;padding:0 !important;}' +
      '.cw-footer-acc ul.footer_menu li a{display:block;padding:7px 0 !important;margin:0 !important;}' +
      '}';
    document.head.appendChild(s);
  }

  function build() {
    addStyle();
    var blocks = document.querySelectorAll('.footer-style3 .footer-block--menu');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.querySelector('.cw-footer-acc')) continue;
      var head = b.querySelector('.footer-block__heading');
      var list = b.querySelector('ul.footer_menu');
      if (!head || !list) continue;
      var d = document.createElement('details');
      d.className = 'cw-footer-acc';
      var sm = document.createElement('summary');
      b.insertBefore(d, head);
      sm.appendChild(head);
      d.appendChild(sm);
      d.appendChild(list);
    }
  }

  function teardown() {
    var accs = document.querySelectorAll('.footer-style3 .cw-footer-acc');
    for (var i = 0; i < accs.length; i++) {
      var d = accs[i];
      var parent = d.parentNode;
      if (!parent) continue;
      var head = d.querySelector('.footer-block__heading');
      var list = d.querySelector('ul.footer_menu');
      if (head) parent.insertBefore(head, d);
      if (list) parent.insertBefore(list, d);
      parent.removeChild(d);
    }
  }

  function sync() {
    try {
      if (mq.matches) { build(); } else { teardown(); }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  setTimeout(sync, 400);
  setTimeout(sync, 1200);

  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
})();


/* Mobile-only spacing between page content and the footer (CW, 30 Aug 2026)
   Collection pages: add white breathing room after the pagination.
   Product pages: remove the excess white space after the review area.
   Applied to the LAST CONTENT SECTION immediately before the footer, so the
   footer itself is never padded or shifted. Cart and every other template are
   left alone. Mobile only. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var MARK = 'cwSpacingApplied';

  function lastSectionBeforeFooter() {
    var footer = document.querySelector('.footer-style3');
    if (!footer) return null;
    var section = footer.closest('.shopify-section') || footer.parentElement;
    if (!section) return null;
    var prev = section.previousElementSibling;
    while (prev && prev.offsetHeight === 0) {
      prev = prev.previousElementSibling;
    }
    return prev;
  }

  function pageType() {
    var p = window.location.pathname;
    if (p.indexOf('/products/') !== -1) return 'product';
    if (p.indexOf('/collections/') !== -1) return 'collection';
    return 'other';
  }

  function apply() {
    try {
      var el = lastSectionBeforeFooter();
      if (!el) return;
      var type = pageType();
      if (!mq.matches || type === 'other') {
        if (el.dataset[MARK]) {
          el.style.removeProperty('padding-bottom');
          el.style.removeProperty('margin-bottom');
          delete el.dataset[MARK];
        }
        return;
      }
      if (type === 'collection') {
        el.style.setProperty('padding-bottom', '36px', 'important');
      } else {
        el.style.setProperty('padding-bottom', '0', 'important');
        el.style.setProperty('margin-bottom', '0', 'important');
      }
      el.dataset[MARK] = '1';
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  setTimeout(apply, 600);
  setTimeout(apply, 1500);

  if (mq.addEventListener) { mq.addEventListener('change', apply); }
  else if (mq.addListener) { mq.addListener(apply); }
})();
